var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_856_48580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.518302 24.8277H29.4838C29.7694 24.8277 30.001 24.596 30.001 24.3104V5.68973C30.001 5.40409 29.7694 5.17247 29.4838 5.17247H0.518302C0.232658 5.17253 0.0010376 5.40409 0.0010376 5.68973V24.3104C0.0010376 24.5961 0.232658 24.8277 0.518302 24.8277Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.001 9.31065H0.0010376V20.6901H30.001V9.31065Z",
    fill: "#FFD250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6733 15.0001L13.1118 13.0266C13.1523 12.8449 13.0139 12.6725 12.8277 12.6725H12.5188C12.3327 12.6725 12.1944 12.8449 12.2347 13.0266L12.6733 15.0001Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1907 13.9653H12.1562V18.3616H13.1907V13.9653Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4488 13.4485H11.8971V13.9658H13.4488V13.4485Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4503 15.0001H10.864V15.5173H13.4503V15.0001Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4502 17.069L11.8984 16.5518V16.0345L13.4502 16.5518V17.069Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91569 15.0001L5.35426 13.0266C5.39469 12.8448 5.25635 12.6724 5.07014 12.6724H4.76124C4.57509 12.6724 4.43681 12.8448 4.47712 13.0266L4.91569 15.0001Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72527 13.4484C6.43963 13.4484 6.20801 13.68 6.20801 13.9656V17.3277C6.20801 17.9561 6.79453 19.138 8.79421 19.138C10.7939 19.138 11.3804 17.9561 11.3804 17.3277V13.9656C11.3804 13.68 11.1488 13.4484 10.8632 13.4484H6.72527Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79501 16.0345H6.2088V13.9656C6.2088 13.6799 6.44042 13.4483 6.72607 13.4483H8.79501V16.0345Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79504 16.0345H11.3813V17.3276C11.3813 18.0418 10.8023 18.6207 10.0881 18.6207C9.37395 18.6207 8.79504 18.0418 8.79504 17.3276V16.0345Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20801 16.0346H8.79421V17.3277C8.79421 18.0419 8.21531 18.6208 7.50111 18.6208C6.78691 18.6208 6.20801 18.0419 6.20801 17.3277V16.0346Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27593 18.3564V16.0346H7.75867V18.5947C7.95109 18.5557 8.12494 18.4705 8.27593 18.3564Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24145 18.5947V16.0346H6.72418V18.3564C6.87524 18.4705 7.04908 18.5557 7.24145 18.5947Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27695 15.0001H6.72522V15.5174H8.27695V15.0001Z",
    fill: "#FFB441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27695 13.9653H6.72522V14.4826H8.27695V13.9653Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01769 14.273H6.98322V15.21H8.01769V14.273Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43163 13.9653H4.39716V18.3616H5.43163V13.9653Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68949 18.1038H4.13776V18.621H5.68949V18.1038Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68949 13.4485H4.13776V13.9658H5.68949V13.4485Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.94943 18.6206H3.88049V19.1379H5.94943V18.6206Z",
    fill: "#5064AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7079 18.1038H12.1562V18.6211H13.7079V18.1038Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7076 18.6206H11.6387V19.1379H13.7076V18.6206Z",
    fill: "#5064AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.346 12.9312H7.24249V13.4484H10.346V12.9312Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05303 11.3796H8.53577V12.9313H9.05303V11.3796Z",
    fill: "#FFB441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27681 12.1553C7.84896 12.1553 7.50098 11.8072 7.50098 11.3794C7.50098 10.9516 7.84902 10.6036 8.27681 10.6036C8.70466 10.6036 9.05265 10.9517 9.05265 11.3794C9.05271 11.8072 8.70466 12.1553 8.27681 12.1553ZM8.27681 11.1208C8.13414 11.1208 8.01818 11.2367 8.01818 11.3794C8.01818 11.5221 8.13408 11.6381 8.27681 11.6381C8.41955 11.6381 8.53545 11.5222 8.53545 11.3794C8.53545 11.2368 8.41955 11.1208 8.27681 11.1208Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3113 12.1553C8.88345 12.1553 8.53546 11.8072 8.53546 11.3794C8.53546 10.9516 8.88351 10.6036 9.3113 10.6036C9.73915 10.6036 10.0871 10.9517 10.0871 11.3794C10.0871 11.8072 9.73909 12.1553 9.3113 12.1553ZM9.3113 11.1208C9.16862 11.1208 9.05267 11.2367 9.05267 11.3794C9.05267 11.5221 9.16857 11.6381 9.3113 11.6381C9.45398 11.6381 9.56993 11.5222 9.56993 11.3794C9.56987 11.2368 9.45398 11.1208 9.3113 11.1208Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3459 12.6725C9.91806 12.6725 9.57007 12.3245 9.57007 11.8967C9.57007 11.4689 9.91811 11.1209 10.3459 11.1209C10.7738 11.1209 11.1217 11.4689 11.1217 11.8967C11.1217 12.3245 10.7737 12.6725 10.3459 12.6725ZM10.3459 11.6381C10.2032 11.6381 10.0873 11.754 10.0873 11.8967C10.0873 12.0394 10.2032 12.1553 10.3459 12.1553C10.4886 12.1553 10.6045 12.0394 10.6045 11.8967C10.6045 11.754 10.4886 11.6381 10.3459 11.6381Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24233 12.6725C6.81448 12.6725 6.46649 12.3245 6.46649 11.8967C6.46649 11.4689 6.81454 11.1209 7.24233 11.1209C7.67018 11.1209 8.01817 11.4689 8.01817 11.8967C8.01823 12.3245 7.67018 12.6725 7.24233 12.6725ZM7.24233 11.6381C7.09965 11.6381 6.9837 11.754 6.9837 11.8967C6.9837 12.0394 7.0996 12.1553 7.24233 12.1553C7.38506 12.1553 7.50096 12.0394 7.50096 11.8966C7.50096 11.754 7.38506 11.6381 7.24233 11.6381Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3457 17.069V17.3277C10.3457 17.4703 10.2297 17.5863 10.0871 17.5863C9.94444 17.5863 9.82842 17.4703 9.82842 17.3277V17.069H10.3457ZM10.8629 16.5518H9.31116V17.3277C9.31116 17.7555 9.6592 18.1035 10.087 18.1035C10.5148 18.1035 10.8628 17.7555 10.8628 17.3277V16.5518H10.8629Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0873 15.5174C9.80163 15.5174 9.57001 15.2857 9.57001 15.0001V14.4828C9.57001 14.1972 9.80163 13.9656 10.0873 13.9656C10.3729 13.9656 10.6045 14.1972 10.6045 14.4828V15.0001C10.6045 15.2857 10.3729 15.5174 10.0873 15.5174Z",
    fill: "#FFA0D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79409 16.8101C9.22257 16.8101 9.56993 16.4627 9.56993 16.0343C9.56993 15.6058 9.22257 15.2584 8.79409 15.2584C8.3656 15.2584 8.01825 15.6058 8.01825 16.0343C8.01825 16.4627 8.3656 16.8101 8.79409 16.8101Z",
    fill: "#5064AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05303 10.3448H8.53577V11.8966H9.05303V10.3448Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24218 12.9311L6.72491 12.4139L7.0279 12.1109C7.49624 11.6426 8.13151 11.3794 8.79392 11.3794C9.45632 11.3794 10.0915 11.6426 10.5599 12.1109L10.8629 12.4139L10.3457 12.9311H7.24218Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79342 12.6723C8.93626 12.6723 9.05205 12.5565 9.05205 12.4137C9.05205 12.2709 8.93626 12.1551 8.79342 12.1551C8.65058 12.1551 8.53479 12.2709 8.53479 12.4137C8.53479 12.5565 8.65058 12.6723 8.79342 12.6723Z",
    fill: "#FFD250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75863 12.6723C7.90147 12.6723 8.01727 12.5565 8.01727 12.4137C8.01727 12.2709 7.90147 12.1551 7.75863 12.1551C7.61579 12.1551 7.5 12.2709 7.5 12.4137C7.5 12.5565 7.61579 12.6723 7.75863 12.6723Z",
    fill: "#FFD250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8276 12.6723C9.97044 12.6723 10.0862 12.5565 10.0862 12.4137C10.0862 12.2709 9.97044 12.1551 9.8276 12.1551C9.68476 12.1551 9.56897 12.2709 9.56897 12.4137C9.56897 12.5565 9.68476 12.6723 9.8276 12.6723Z",
    fill: "#FFD250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72408 15.0001H4.13776V15.5174H6.72408V15.0001Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13776 17.0691L5.68943 16.5519V16.0346L4.13776 16.5519V17.0691Z",
    fill: "#C8414B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_856_48580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.695d9ab753c0c300bcb15999f5523461.svg";
export { ForwardRef as ReactComponent };